export const CurrencyShop = () => (
  <div className="generalReferenceForm">
    <div className="generalFormBody">
      <label htmlFor="currency-euro">
        Moneda
        <select id="currency-euro" value="EUR" disabled>
          <option value="EUR">Euro (€)</option>
        </select>
      </label>
      <p>Delibran trabaja únicamente en euros.</p>
    </div>
    <div className="generalSaveFooter">
      <span>Sin cambios disponibles</span>
      <button type="button" disabled>
        Guardar
      </button>
    </div>
  </div>
);
